<template>
  <div>
    <h5>Contact</h5>

    <p>Change the site contact for this student opportunity.</p>

    <b-form @submit.prevent="submit()" class="form-horizontal">
      <div v-if="supervisors && supervisors.length">
      <b-form-group label="Select a contact" label-class="control-label" :class="{ 'invalid-group': $v.form.siteContactId.$error }">
        <b-form-select :class="{ 'is-invalid': $v.form.siteContactId.$error }"
                        v-model="form.siteContactId"
                        :disabled="hasNewContact"
                        :options="supervisorOptions"
                        value-field="siteContactId"
                        text-field="text"
                        @input="setContact()">
          <template slot="first">
            <!-- this slot appears above the options from 'options' prop -->
            <option value="">None</option>
          </template>
        </b-form-select>
        <span class="span-feedback invalid-feedback" v-if="$v.form.siteContactId.$error">You must select a contact or enter a new contact below.</span>
      </b-form-group>

      <b-col sm="12" class="text-center">-- OR --</b-col>
      </div>

      <b-form-group label="First Name" label-class="control-label" :class="{ 'invalid-group': $v.form.firstName.$error }">
        <b-form-input v-model="form.firstName" :disabled="hasSupervisor" :class="{ 'is-invalid': $v.form.firstName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.firstName.$error">You must enter a first name.</span>
      </b-form-group>

      <b-form-group label="Last Name" label-class="control-label" :class="{ 'invalid-group': $v.form.lastName.$error }">
        <b-form-input v-model="form.lastName" :disabled="hasSupervisor" :class="{ 'is-invalid': $v.form.lastName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.lastName.$error">You must enter a last name.</span>
      </b-form-group>

      <b-form-group label="Title" label-class="control-label" :class="{ 'invalid-group': $v.form.title.$error }">
        <b-form-input v-model="form.title" :disabled="hasSupervisor" :class="{ 'is-invalid': $v.form.title.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.title.$error">You must enter a title.</span>
      </b-form-group>
      
      <b-form-group label="Phone Number" label-class="control-label" :class="{ 'invalid-group': $v.form.phoneNumber.$error }">
        <b-form-input v-model="form.phoneNumber" :disabled="hasSupervisor" :class="{ 'is-invalid': $v.form.phoneNumber.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.phoneNumber.$error">You must enter a valid phone number.</span>
      </b-form-group>

      <b-form-group label="Email" label-class="control-label" :class="{ 'invalid-group': $v.form.email.$error }">
        <b-form-input v-model="form.email" :disabled="hasSupervisor" :class="{ 'is-invalid': $v.form.email.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.email.$error">You must enter an email.</span>
      </b-form-group>

      <b-btn variant="primary" type="submit" class="ml-2 pull-right" >Save</b-btn>
      <b-btn variant="secondary" @click="cancel()" class="ml-2 pull-right">Cancel</b-btn>

    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        title: "",
        phoneNumber: "",
        email: "",
        siteContactId: 0
      },
      supervisorOptions: []
    };
  },

  props: {
    supervisors: {
      required: false
    }
  },

  computed: {
    hasSupervisor: function() {
      return this.form.siteContactId > 0;
    },
    hasNewContact: function() {
      return (
        !this.form.siteContactId &&
        (!!this.form.firstName &&
          !!this.form.lastName &&
          !!this.form.title &&
          !!this.form.phoneNumber &&
          !!this.form.email)
      );
    }
  },

  validations() {
    if (this.hasSupervisor) {
      return {
        form: {
          siteContactId: { required },
          firstName: {},
          lastName: {},
          title: {},
          phoneNumber: {},
          email: {}
        }
      };
    } else if (this.hasNewContact) {
      return {
        form: {
          siteContactId: {},
          firstName: {
            required
          },
          lastName: {
            required
          },
          title: {
            required
          },
          phoneNumber: {
            required
          },
          email: {
            required
          }
        }
      };
    } else {
      return {
        form: {
          siteContactId: { required },
          firstName: {
            required
          },
          lastName: {
            required
          },
          title: {
            required
          },
          phoneNumber: {
            required
          },
          email: {
            required
          }
        }
      };
    }
  },

  methods: {
    submit: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submitted", this.form);
      }
    },

    cancel: function() {
      this.$emit("cancel");
    },

    mapSupervisors: function(supervisors) {
      return _.map(supervisors, function(supervisor) {
        return {
          siteContactId: supervisor.siteContactId,
          text: supervisor.firstName + " " + supervisor.lastName
        };
      });
    },
    setContact() {
      var that = this;
      var contact = _.filter(this.supervisors, function(supervisor) {
        return supervisor.siteContactId === that.form.siteContactId;
      })[0];
      if (contact) {
        this.form.siteContactId = contact.siteContactId;
        this.form.firstName = contact.firstName;
        this.form.lastName = contact.lastName;
        this.form.title = contact.title;
        this.form.phoneNumber = contact.phoneNumber;
        this.form.email = contact.email;
      } else {
        this.form.siteContactId = 0;
        this.form.firstName = "";
        this.form.lastName = "";
        this.form.title = "";
        this.form.phoneNumber = "";
        this.form.email = "";
      }
    }
  },

  watch: {
    supervisors: {
      handler: function() {
        this.supervisorOptions = this.mapSupervisors(this.supervisors);
      }
    }
  },

  created() {
    this.supervisorOptions = this.mapSupervisors(this.supervisors);
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
